/**
 * Route the knowledge console exposes for a single article (`front#SPEC-002`,
 * Slice 1). Keyed on `sourceId` because that is what the backend routes on
 * (`GET|PUT /articles/{source_id}`, `back#SPEC-008`) — linking by `fileName`
 * would force a lookup by name to get there.
 */
export const KNOWLEDGE_ARTICLE_PATH = '/knowledge/articles';

export const I18N_PREFIX = 'toolCall';
